module.exports = __webpack_public_path__ + "img/charging-hub-rejected-semipublic.cad291c2.png";